import { convertToHTML } from 'draft-convert';
import React from 'react';
import {
  ContentBlock, ContentState, EditorState, RawDraftInlineStyleRange,
} from 'draft-js';
import { PerfectTextEditorBlockAlignment } from './perfect-text-editor.enums';

interface InlineStyleRange extends Omit<RawDraftInlineStyleRange, 'style'> {
  style: string;
}

export const contentToHtml = (content: ContentState): string => {
  return convertToHTML({
    // eslint-disable-next-line consistent-return
    blockToHTML: (block) => {
      let toReturn;
      if (block.text.length === 0) {
        return React.createElement('br', null);
      }

      block.inlineStyleRanges.forEach(({ style }: InlineStyleRange) => {
        if (style === PerfectTextEditorBlockAlignment.Right) {
          toReturn = React.createElement('p', { style: { 'text-align': 'right' } });
        } else if (style === PerfectTextEditorBlockAlignment.Left) {
          toReturn = React.createElement('p', { style: { 'text-align': 'left' } });
        } else if (style === PerfectTextEditorBlockAlignment.Center) {
          toReturn = React.createElement('p', { style: { 'text-align': 'center' } });
        }
      });

      if (toReturn) {
        return toReturn;
      }
    },
  })(content);
};

export const newEntityLocationStrategy = (type: string) => {
  return (
    contentBlock: ContentBlock,
    callback: (start: number, end: number) => void,
    contentState: ContentState,
  ): void => {
    contentBlock.findEntityRanges((character) => {
      const entityKey = character.getEntity();

      return (
        entityKey !== null &&
        contentState.getEntity(entityKey)
          .getType() === type
      );
    }, callback);
  };
};

export const getCaretPosition = (editorState: EditorState): number => {
  return editorState.getSelection().getAnchorOffset();
};

export const getCurrentBlock = (editorState: EditorState): ContentBlock | null => {
  if (editorState.getSelection) {
    const selectionState = editorState.getSelection();
    const contentState = editorState.getCurrentContent();

    return contentState.getBlockForKey(selectionState.getStartKey());
  }

  return  null;
};

export const getText = (editorState: EditorState, start: number, end: number): string => {
  const block = getCurrentBlock(editorState);
  const blockText = block?.getText();

  return blockText?.substring(start, end) || '';
};
